import React from "react"
import Dropdown from "../../../../Dropdown/Dropdown"
import { options } from "./options"
import { setArticleType } from "../../useReducer/actionCreators"
import useOption from "./useOption"

const ArticleTypeDropdown = ({ externalDispatch, selectedType }) => {
  const [option, setOption] = useOption(selectedType)
  return (
    <Dropdown
      label="Topic Type"
      id="article_type_dropdown"
      options={options}
      value={option}
      onChange={(option) => {
        setOption(option)
        externalDispatch(setArticleType(option.id))
      }}
    />
  )
}
export default ArticleTypeDropdown
